import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import {ReactComponent as ReDesignBg1} from '../../assets/images/bg-1.svg';
import {ReactComponent as ReDesignBg2} from '../../assets/images/bg-2.svg';
// import  ReDesignBg2 from '../../assets/images/bg-2.png';
import {ReactComponent as ReDesignBg3} from '../../assets/images/bg-3.svg';
import {ReactComponent as ReDesignGirlDef} from '../../assets/images/redesign-girl-default.svg';
import {ReactComponent as Head1} from '../../assets/images/head-1.svg';
import {ReactComponent as Head2} from '../../assets/images/head-2.svg';
import {ReactComponent as Head3} from '../../assets/images/head-3.svg';
import {ReactComponent as Torso1} from '../../assets/images/torso-1.svg';
import {ReactComponent as Torso2} from '../../assets/images/torso-2.svg';
import {ReactComponent as Torso3} from '../../assets/images/torso-3.svg';
import {ReactComponent as Legs1} from '../../assets/images/legs-1.svg';
import {ReactComponent as Legs2} from '../../assets/images/legs-2.svg';
import {ReactComponent as Legs3} from '../../assets/images/legs-3.svg';
import {gsap, ScrollTrigger, MotionPathPlugin ,TimelineMax} from 'gsap/all';
import TorsoExpansion from './torso-expansion';
import FaceExpansion from './face-expansion';
import BgExpansion from './bg-expansion';
import LegsExpansion from './legs-expansion';

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

export default function ReDesign() {

  let redesignRef = useRef(null);
  let defaultGirlRef = useRef(null);
  let defaultTextRef = useRef(null);
  let btn1Ref = useRef(null);
  let btn2Ref = useRef(null);
  let btn3Ref = useRef(null);
  let btn4Ref = useRef(null);

  const [expandOnce, setExpandOnce] = useState(false);

  const [currentBg, setCurrentBg] = useState(1);
  const [currentHead, setCurrentHead] = useState(1);
  const [currentTorso, setCurrentTorso] = useState(1);
  const [currentLegs, setCurrentLegs] = useState(1);

  let tl = gsap.timeline();
  let tl2 = gsap.timeline();
  
  useEffect(() => {
    if( window.innerWidth >= 769 ) {
    gsap.to(redesignRef.current, {
      scrollTrigger: {
        start: '+1200px 45%',
        end: '+1200px 10%',
        scrub: true,
        // markers: true,
        pinSpacing: true,
        onEnter: () => {
          // alert(1)
          // document.getElementsByClassName('circle')[0].style.display = 'block';
          setExpandOnce(true);
          // console.log('--- on exopand called ---');
            tl2.to('.fold2btn1', {
              left:"5%",
              opacity: 1,
              duration: 0.3
            })
            tl2.to(".fold2btn", {
              right:"0%",
              opacity: 1,
              duration: 0.3
            })
            tl2.to(".fold2btn2", {
              right:"10%",
              opacity: 1,
              duration: 0.3
            })
        },
        onEnterBack: () => {
          // alert(2)
        },
        onLeave: () => {

        },
        onLeaveBack: () => {
          // alert(3)
          // document.getElementsByClassName('circle')[0].style.display = 'hidden';
         setExpandOnce(false);
         tl2.to(".fold2btn2", {
          right:"-20%",
          opacity: 0,
          duration: 0.3
        })
        tl2.to(".fold2btn1", {
          left:"-20%",
          opacity: 0,
          duration: 0.3
        })
        tl2.to(".fold2btn", {
          right:"-20%",
          opacity: 0,
          duration: 0.3
        })
        }
      },
      opacity: 1,
    });
    
    if (window.innerWidth >= 769) {
      gsap.fromTo(defaultGirlRef.current, {
        y: -890,
        x: -550,
        transform: 'scale(1) rotate(15deg)'
      },{
        scrollTrigger: {
          trigger: redesignRef.current,
          start: '+600px 100%',
          end: '+700px 10%',
          scrub: true,
          // markers: true,
          // pin: true,
          pinSpacing: true,
          
        },
        x: 0,
        y: 0,
        // left: 500,
        // top: 1000,
        transform: `rotate(0deg)`,
        duration: 5
      });
    }
  } else {
    setExpandOnce(true);
  }
 
  }, [])
  
  useEffect(() => {
    if ( window.innerWidth >= 769 ) {
      if (expandOnce) {
        
       tl.to(".textdesc", {
         opacity: 1,
         duration: 0.1,
         stagger:0.1
 
       }).yoyo()
      } else {
        tl.to(".textdesc", {
          opacity: 0,
          duration: 0.1,
          stagger:0.1
  
        }).yoyo()
      }
    }
  },[expandOnce]);

  useEffect(() => {
    if ( window.innerWidth >= 769 ) {
      if ( expandOnce ) {
        
        tl.to(".fold2bg", {
          opacity: 1,
          duration: 0.3
        })
      } else {
        tl.to(".fold2bg", {
          opacity: 0,
          duration: 0.3
        })
      }
    }
  },[expandOnce]);


  useEffect(() => {
    if (window.mobileCheck() === false) {
      const circle = document.querySelector('.circle');
      const link = document.querySelectorAll('.interact-icon');
      const open = document.querySelectorAll('.open-link');
      const redesignWrapper = document.querySelector('.custom-cursor-container');
      window.addEventListener('mousemove', mouseMoveHandler);
      window.addEventListener('mousedown', mouseDownHandler);
      window.addEventListener('mouseup', mouseUpHandler);
      link.forEach( el => el.addEventListener('mouseenter', linkEnterHandler));
      link.forEach( el => el.addEventListener('mouseleave', linkLeaveHandler));
      open.forEach( el => el.addEventListener('mouseenter', openEnterHandler));
      open.forEach( el => el.addEventListener('mouseleave', openLeaveHandler));
      
      function mouseMoveHandler(e) {
        circle.style.left = e.clientX - circle.offsetWidth / 2 + "px";
        circle.style.top = e.clientY - circle.offsetHeight / 2 + "px";
        circle.style.opacity = 1;
      }

      function mouseUpHandler(e) {
        circle.style.transform = "scale(1)";
      }

      function mouseDownHandler() {
        circle.style.transform = "scale(1.5)";
      }

      function linkEnterHandler() {
        circle.style.transform = "scale(2.5)";
        circle.style.borderColor = 'rgb(118, 92,255)';
        circle.style.backgroundColor = "rgba(118, 92,255, 1)";
        circle.innerHTML = 'Click'
      }

      function linkLeaveHandler() {
        circle.style.transform = "scale(1)";
        circle.innerHTML = ''
      }

      function openEnterHandler() {
        circle.style.transform = "scale(2.5)";
        circle.style.border = 'rgb(118, 92,255)';
        circle.style.backgroundColor = "rgba(118, 92,255, 1)";
        circle.innerHTML = 'Open'
      }

      function openLeaveHandler() {
        circle.style.transform = "scale(1)";
        circle.innerHTML = '';
      }
    } else {
      document.getElementsByClassName('circle')[0].style.display = 'none';
    }
  }, []);

  function throttle(fn, wait) {
    var time = Date.now();
    return function() {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    }
  }

  function isDescendant(parent, child) {
    var node = child.parentNode;
    while (node != null) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
  }

  return (
    <div 
      ref={redesignRef}
      style={{paddingTop: '650px'}}
      className='re-design-wrapper w-full px-2 py-2 lg:px-16 lg:py-16 flex justify-center flex-wrap  pt-64 bg-red-50'>
        <div
        className="textdesc"
        ref={defaultTextRef}>
      <h1 
       // style={{opacity: expandOnce ? 1 : 0}} 
        className='w-full text-3xl sm:text-6xl font-extrabold text-center'
        style={{wordBreak: "break-word", lineHeight: '3.4rem'}}>
         <span className="main-font block w-full sm:inline-block leading-4"> Design, rotate and </span> 
         <span className="main-font block w-full sm:inline-block">place the elements</span> 
         <span className="main-font block sm:inline-block leading-4">however you like </span>
      </h1>
      <div className='w-full  mt-4 ml-16 font-light not-italic text-2xl sm:ml-0  '>
        <p className='w-4/6 sm:w-full text-center secondary-font story-free-comm onall-wrapper subtext'>
          Choose from Hey's sustainable collection of multiple 
        </p>
        <p className='w-4/6 sm:w-full text-center secondary-font story-free-comm onall-wrapper subtext'>  
          styles to easily create your own story.
        </p>
      </div>
      </div>
      <div
        //style={{opacity: expandOnce ? 1 : 0}} 
        className='custom-cursor-container w-full xl:w-3/4 flex justify-center pt-4 relative'>
        {
          currentBg === 1 && <ReDesignBg1 className='fold2bg' style={{width: '600px'}}/>
        }
        {
          currentBg === 2 && <ReDesignBg2 className='fold2bg' style={{width: '600px'}}/>
          // currentBg === 2 && <img src={ ReDesignBg2 } className='fold2bg' style={{width: '600px'}}/>
        }
        {
          currentBg === 3 && <ReDesignBg3 className='fold2bg' style={{width: '600px'}}/>
        }
        <div
          ref={defaultGirlRef}
          className='re-design-person absolute mr-auto z-1 text-center flex flex-wrap justify-center bg-yellow-60'
          style={{width: '300px', marginTop: '-40px', transform: 'scale(0.8)'}}>
            { currentHead === 1 && <Head1 className='relative' style={{top: '50px', left: '-20px'}}/> }
            { currentHead === 2 && <Head2 className='relative' style={{top: '50px'}}/> }
            { currentHead === 3 && <Head3 className='relative' style={{top: '50px'}}/> }
            
            { currentTorso === 1 && <Torso1 className='relative' style={{zIndex: 2, left: '57px', top: '10px'}}/> }
            { currentTorso === 2 && <Torso2 className='relative' style={{zIndex: 2}}/> }
            { currentTorso === 3 && <Torso3 className='relative' style={{zIndex: 2, top: '40px'}}/> }
            
            { currentLegs === 1 && <Legs1 className='relative' style={{top: '-20px', left: '20px'}}/> }
            { currentLegs === 2 && <Legs2 className='relative' style={{top: '-20px', height: '245px'}}/> }
            { currentLegs === 3 && <Legs3 className='relative' style={{top: '-20px'}}/> }
            
        </div>
        {/* <ReDesignGirlDef
          ref={defaultGirlRef}
          className='absolute mr-auto border-2 border-red-300 z-10'
          style={{width: '300px', marginTop: '-50px'}}
        /> */}
        <div ref={btn1Ref} style={{top: '20px', left: '-20%'}} className='absolute hidden lg:block f2btn fold2btn1' >
          <TorsoExpansion expandOnce={expandOnce} handleChange={setCurrentTorso}/>
        </div>
        <div ref={btn2Ref} style={{bottom: '20px', right: '-20%'}} className='absolute hidden lg:block f2btn1 fold2btn2' >
          <FaceExpansion expandOnce={expandOnce} handleChange={setCurrentHead}/>
        </div>
        <div style={{top: '50px', right: '-20%'}} className='absolute hidden lg:block f2btn2 fold2btn' >
          <BgExpansion expandOnce={expandOnce} handleChange={setCurrentBg}/>
        </div> 
        <div style={{bottom: '50px', left: '-20%'}} className='absolute hidden lg:block f2btn3 fold2btn1' >
          <LegsExpansion expandOnce={expandOnce} handleChange={setCurrentLegs}/>
        </div>
      </div>
      <div className="lg:hidden w-full flex mt-2"> 
      <div className='w-1/4 fold2btn1 ' >
          <TorsoExpansion expandOnce={expandOnce} handleChange={setCurrentTorso}/>
        </div>
        <div  className='w-1/4 fold2btn1' >
          <LegsExpansion expandOnce={expandOnce} handleChange={setCurrentLegs}/>
        </div>
        <div  className='w-1/4 fold2btn2' >
          <FaceExpansion expandOnce={expandOnce} handleChange={setCurrentHead}/>
        </div>
        <div  className='w-1/4 fold2btn' >
          <BgExpansion expandOnce={expandOnce} handleChange={setCurrentBg}/>
        </div> 
       
        </div>
    </div>
  )
}

